// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bcefb7c2","455":"856b460d","551":"4a742541","977":"2724f420"}[chunkId] + ".chunk.js";
};